import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react";

export const SortableHeader = ({ label, sortKey, sortState, onSort, className = "" }) => {
  const isActive = sortState.key === sortKey;
  const icon = isActive
    ? sortState.dir === "asc" ? <ArrowUp className="w-3 h-3" /> : <ArrowDown className="w-3 h-3" />
    : <ArrowUpDown className="w-3 h-3 opacity-0 group-hover:opacity-50" />;

  return (
    <button
      type="button"
      className={`group flex items-center gap-1 text-xs uppercase tracking-wider font-semibold ${isActive ? "text-[#0D9488]" : "text-slate-500"} hover:text-[#0D9488] transition-colors ${className}`}
      onClick={() => onSort(sortKey)}
    >
      {label} {icon}
    </button>
  );
};

export const getPersistedSort = (page, defaultKey, defaultDir = "asc") => {
  try {
    const saved = localStorage.getItem(`sort_${page}`);
    if (saved) return JSON.parse(saved);
  } catch { /* ignore */ }
  return { key: defaultKey, dir: defaultDir };
};

export const toggleSort = (prev, key, page) => {
  const next = { key, dir: prev.key === key && prev.dir === "asc" ? "desc" : "asc" };
  try { localStorage.setItem(`sort_${page}`, JSON.stringify(next)); } catch { /* ignore */ }
  return next;
};

export const applySortFn = (sortState) => (a, b) => {
  if (!sortState.key) return 0;
  const aVal = a[sortState.key];
  const bVal = b[sortState.key];
  if (aVal == null && bVal == null) return 0;
  if (aVal == null) return 1;
  if (bVal == null) return -1;
  const cmp = typeof aVal === "number" ? aVal - bVal : String(aVal).localeCompare(String(bVal));
  return sortState.dir === "asc" ? cmp : -cmp;
};
